import React, {useState, useEffect} from 'react';
import {Modal, Form, Input, DatePicker, Select,} from 'antd';
import moment from 'moment';


export default function StudentInfoModal ({ modalIsEditing, visible, record, onCreate, onUpdate, onCancel }) {
    const [gradeDataSource, setGradeDataSource] = useState([]);
    const [semesterDataSource, setSemesterDataSource] = useState([]);

    const {Option} = Select;
    const [form] = Form.useForm();
    const [title, setTitle] = useState('');
    const [okText, setOkText] = useState('');

    useEffect(() => {
        fetch('https://kh-studentrecordsystem.herokuapp.com/gradesInfo')
            .then(response => response.json())
            .then(data => {setGradeDataSource(data.Data)})
            .catch(err => console.log(err));
        fetch('https://kh-studentrecordsystem.herokuapp.com/semestersInfo')
            .then(response => response.json())
            .then(data => {setSemesterDataSource(data)})
            .catch(err => console.log(err));
        form.setFieldsValue({            
            studentGrade: (record) ? record.grade : "",
            studentSemester: (record) ? record.semester : "",
            firstName: (record) ? record.firstName : "",
            lastName: (record) ? record.lastName : "",
            dob: (record) ? record.dob ? moment(record.dob, "DD-MMM-YYYY") : null : null,
            age: (record) ? record.age : "",
            gender: (record) ? record.gender : "",
            contact: (record) ? record.contact : "",
        }) 
        modalSetting(modalIsEditing)
    }, [form, modalIsEditing, record])



    const modalSetting = (isEditing) => {
        if (isEditing === false) {
            setTitle('Create a new student');
            setOkText('Create');
        } else {
            setTitle('Update a student information');
            setOkText('Update');
        }        
    }

    const handleDatepickerChange = (date) => {
        let birthYear = String(date._d.getFullYear());
        let birthMonth = String(date._d.getMonth() + 1);
        let birthDate = String(date._d.getDate());
    
        let d = new Date();
        let nowYear = d.getFullYear();
        let nowMonth = d.getMonth() + 1;
        let nowDate = d.getDate();        
    
        let yearDiff = nowYear - birthYear;
        let monthDiff = nowMonth - birthMonth;
        let dateDiff = nowDate - birthDate;
        let returnAge = 0;

        if (yearDiff < 0) {
            returnAge = -1;
            alert("Are you sure he/she is born??");
        } else if (yearDiff === 0) {
            if (monthDiff >= 0 && dateDiff > 0) {
                returnAge = 0;
            } else {
                returnAge = -1;
                alert("Are you sure he/she is born??");
            }
        } else {
            if (monthDiff < 0 || (monthDiff === 0 && dateDiff <= 0)) {
                returnAge = yearDiff - 1;
            } else {
                returnAge = yearDiff;
            }
        }
        return returnAge;
    }

    const studentModalCancel = () => {
        onCancel();
        form.resetFields();
    } 

    return (
        <Modal
            visible={visible}
            title={title}
            okText={okText}
            cancelText="Cancel"
            onCancel={studentModalCancel}
            onOk={() => {
                form
                    .validateFields()
                    .then((values) => {
                        form.resetFields();
                        if (modalIsEditing === false) {
                            onCreate(values)
                        } else {
                            onUpdate(values)
                        }
                    })
                    .catch((info) => {console.log('Validate Failed:', info);});
            }}
            destroyOnClose={true}
            forceRender={true} //important
        >
            <Form form={form} layout="horizontal" preserve={false}>
                <div>
                    <Form.Item
                        label="Current Grade"
                        name="studentGrade"
                        rules={[{required: true}]}  
                    >
                        <Select placeholder="--Please Select--" allowClear>
                            {gradeDataSource.map(x => (
                                <Option key={x._id}>{x.grade}</Option> 
                            ))}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        label="Current Semester"
                        name="studentSemester"
                        rules={[{required: true}]}   
                    >
                        <Select placeholder="--Please Select--" allowClear>
                            {semesterDataSource.map(x => (
                                <Option key={x._id}>{x.semester}</Option>
                            ))}
                        </Select>
                    </Form.Item>
                </div>

                <div>
                    <Form.Item
                        name="firstName"
                        label="First Name"
                        rules={[
                            {
                            required: true,
                            message: 'Please input the First Name!',
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        name="lastName"
                        label="Last Name"
                        rules={[
                            {
                            required: true,
                            message: 'Please input the Last Name!',
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>
                </div>

                <div>
                    <Form.Item
                        name="dob"
                        label="Date Of Birth"
                        rules={[
                            {
                            required: true,
                            message: 'Please select the date of birth!',
                            },
                        ]}
                    >
                        <DatePicker format={"DD-MMM-YYYY"} style={{width: "100%"}} placeholder="--Please Select--" onChange={(date) => {form.setFieldsValue({age: handleDatepickerChange(date)})}}/>
                    </Form.Item>

                    <Form.Item
                        name="age"
                        label="Age"                       
                    >
                        <Input disabled={true}/>
                    </Form.Item>

                    <Form.Item
                        name="gender"
                        label="Gender"
                        rules={[
                            {
                            required: true,
                            message: 'Please select the gender!',
                            },
                        ]}
                    >
                        <Select placeholder="--Please Select--">
                            <Option value="Male">Male</Option>
                            <Option value="Female">Female</Option>
                            <Option value="Other">Other</Option>
                        </Select>
                    </Form.Item>
                </div>
                
                <Form.Item 
                    name="contact" 
                    label="Emergency Contact" 
                >
                    <Input/>
                </Form.Item>

                
            </Form>
        </Modal>
    );
};